var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.8503 0H7.14973C3.20735 0 0 3.20735 0 7.14973V16.8503C0 20.7926 3.20735 24 7.14973 24H16.8503C20.7926 24 24 20.7926 24 16.8503V7.14973C24 3.20735 20.7926 0 16.8503 0ZM21.5856 16.8503C21.5856 19.4655 19.4655 21.5856 16.8503 21.5856H7.14973C4.5345 21.5856 2.4144 19.4655 2.4144 16.8503V7.14973C2.4144 4.53446 4.5345 2.4144 7.14973 2.4144H16.8503C19.4655 2.4144 21.5856 4.53446 21.5856 7.14973V16.8503Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M12.0002 5.79297C8.57754 5.79297 5.79297 8.57754 5.79297 12.0002C5.79297 15.4228 8.57754 18.2074 12.0002 18.2074C15.4229 18.2074 18.2075 15.4229 18.2075 12.0002C18.2075 8.57749 15.4229 5.79297 12.0002 5.79297ZM12.0002 15.7931C9.90547 15.7931 8.20737 14.095 8.20737 12.0002C8.20737 9.90547 9.90551 8.20737 12.0002 8.20737C14.095 8.20737 15.7931 9.90547 15.7931 12.0002C15.7931 14.0949 14.0949 15.7931 12.0002 15.7931Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M18.2198 7.32625C19.0412 7.32625 19.7071 6.66034 19.7071 5.8389C19.7071 5.01747 19.0412 4.35156 18.2198 4.35156C17.3983 4.35156 16.7324 5.01747 16.7324 5.8389C16.7324 6.66034 17.3983 7.32625 18.2198 7.32625Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagramLogo.38d411845a3060c1a2b0a3e7bf750c87.svg";
export { ForwardRef as ReactComponent };